import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { Heading, Paragraph, Box, StepLine, Step, ActionButton } = designSystem;

const DifmOrderFormSteps = ({ captions, steps, isDesktopView, onStepButtonClick }) => (
  <Box
    {...(isDesktopView
      ? {
          padding: 'spacing-xl',
          paddingTop: 'spacing-3-xl',
          paddingBottom: 'spacing-m',
        }
      : {
          padding: 'spacing-xs',
          paddingTop: 'spacing-3-xs',
          paddingBottom: 'spacing-m',
        })}
  >
    <Box marginBottom="spacing-3-xs">
      <Heading type="heading-3">{captions.title}</Heading>
    </Box>
    <Box marginBottom="spacing-m">
      <Paragraph>{captions.description}</Paragraph>
    </Box>
    <StepLine orientation={isDesktopView ? 'vertical' : 'horizontal'} gap="spacing-2-xs">
      {steps.map(({ id, marker, active, passed, completed, invalid, disabled, isInteractive }) => (
        <Step
          key={id}
          marker={marker}
          active={active}
          passed={passed}
          completed={completed}
          invalid={invalid}
          disabled={disabled}
          {...(!isDesktopView && {
            label: captions.steps[id],
            onClick: isInteractive ? () => onStepButtonClick(id) : null,
          })}
        >
          {isDesktopView && (
            <div>
              {isInteractive ? (
                <ActionButton
                  format="text"
                  disabled={disabled}
                  label={captions.steps[id]}
                  onClick={() => onStepButtonClick(id)}
                />
              ) : (
                <Heading type="heading-6" {...(disabled && { appearance: 'low-emphasis' })}>
                  {captions.steps[id]}
                </Heading>
              )}
            </div>
          )}
        </Step>
      ))}
    </StepLine>
  </Box>
);

DifmOrderFormSteps.propTypes = {
  captions: PropTypes.shape().isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      marker: PropTypes.number.isRequired,
      active: PropTypes.bool.isRequired,
      passed: PropTypes.bool.isRequired,
      completed: PropTypes.bool.isRequired,
      invalid: PropTypes.bool.isRequired,
      disabled: PropTypes.bool.isRequired,
      isInteractive: PropTypes.bool.isRequired,
    })
  ).isRequired,
  isDesktopView: PropTypes.bool.isRequired,
  onStepButtonClick: PropTypes.func.isRequired,
};

export default DifmOrderFormSteps;
